import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import { Vendor, VendorType } from '../../modules/vendors';
import Table, { ColumnsType } from 'antd/lib/table';
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  MenuProps,
  Popconfirm,
  Row,
  Space,
  Tag,
} from 'antd';
import { corporateNumberFormatter } from '../../util/utils';
import { EnterpriseType1 } from '../../modules/auth';
import { SearchOutlined } from '@ant-design/icons';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface VendorCompanyListComponentProps {
  onDelete: (vendorId: string) => void;
  onSearch: (values: any, vendorType: VendorType) => void;
  data: Vendor[] | null;
  moveToCreatePage: (vendorType: VendorType, menuType: string) => void;
  moveToDetailPage: (vendorId: number) => void;
}

function VendorCompanyListComponent({
  onDelete,
  onSearch,
  data,
  moveToCreatePage,
  moveToDetailPage,
}: VendorCompanyListComponentProps) {
  const [form] = Form.useForm();
  const columns: ColumnsType<Vendor> = [
    {
      title: '회사명',
      dataIndex: ['application', 'general', 'name'],
      defaultSortOrder: 'ascend',
      sorter: (a: Vendor, b: Vendor) =>
        a.application.general.name.localeCompare(b.application.general.name),
      width: '20%',
      render: (text: any, record: any) => (
        <>
          <span
            className="clickable-table-item"
            onClick={() => moveToDetailPage(record.id)}
          >
            {text}
          </span>
        </>
      ),
    },
    {
      title: '대표명',
      dataIndex: ['application', 'general', 'representativeName'],
      width: '10%',
      render: (text: any, record: any, index: any) => <>{text}</>,
    },
    {
      title: '사업자등록번호',
      dataIndex: ['application', 'general', 'corporateNumber'],
      width: '10%',
      render: (text: string, record: any, index: any) =>
        text === undefined ? '' : corporateNumberFormatter(text),
    },
    {
      title: '종류',
      dataIndex: ['application', 'general', 'type1'],
      width: '10%',
      render: (text: any, record: any, index: any) => (
        <>
          {text === EnterpriseType1.CONTRACTOR
            ? '시공'
            : text === EnterpriseType1.MATERIAL_VENDOR
            ? '자재'
            : ''}
        </>
      ),
    },
    {
      title: '주력공종',
      dataIndex: ['application', 'general', 'type3'],
      width: '30%',
      render: (text: any, record: any, index: any) =>
        record.application.general.type3 === undefined
          ? null
          : record.application.general.type3.map((tag: any, index: any) => (
              <Tag key={index}>{tag}</Tag>
            )),
    },
    {
      title: '',
      key: 'action',
      dataIndex: '',
      align: 'center',
      width: '10%',
      render: (text, record, index) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              data-test={`project-list-item-${index}`}
              onConfirm={() => onDelete(record.id + '')}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: '직접입력',
    },
    {
      key: '2',
      label: '엑셀 일괄등록',
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    console.log('click', e);
    moveToCreatePage(VendorType.COMPANY, e.key);
  };

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Space>
          <Form
            form={form}
            name="advanced_search"
            className="ant-advanced-search-form"
            layout="inline"
            size="small"
            onFinish={() => onSearch(form.getFieldsValue(), VendorType.COMPANY)}
          >
            <Row style={{ height: '20px' }} justify={'start'}>
              <Col flex={6}>
                <Form.Item name="name">
                  <Input
                    placeholder="사업자명을 입력 후 엔터키를 누르세요."
                    style={{ width: '300px' }}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col flex={1}>
                <Button
                  htmlType="submit"
                  icon={<SearchOutlined rev={undefined} />}
                >
                  검색
                </Button>
              </Col>
            </Row>
          </Form>
        </Space>
        <Col>
          <Dropdown.Button
            menu={{ items, onClick: handleMenuClick }}
            placement="bottom"
            arrow
            size="small"
            style={{ marginRight: '70px' }}
          >
            더보기
          </Dropdown.Button>

          {/* <Button
              size="small"
              icon={<DownloadOutlined rev={undefined} />}
              onClick={() => downloadFile(data)}
            >
              다운로드
            </Button> */}
        </Col>
      </Row>

      {data && (
        <Table<Vendor>
          rowKey="id"
          locale={{
            triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
            triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
            cancelSort: '정렬을 취소하려면 클릭하세요.',
          }}
          columns={columns}
          dataSource={data}
          style={{ marginTop: '10px' }}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
        />
      )}
    </StyledDiv>
  );
}
export default VendorCompanyListComponent;
